import Rollbar from 'rollbar/replay';

import {BUILD_ID, ROLLBAR_TOKEN} from '@/shared/config';

let rollbarInstance: Rollbar | null = null;

export const getRollbar = (): Rollbar => {
  if (!rollbarInstance) {
    throw new Error('Rollbar instance is not initialized');
  }

  return rollbarInstance;
};

export const init = ({enabled = true}: {enabled: boolean}): Rollbar => {
  rollbarInstance = new Rollbar({
    accessToken: ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: import.meta.env.MODE,
    enabled,
    itemsPerMinute: 5,
    maxItems: 30,
    addErrorContext: true,
    scrubFields: ['email'],
    payload: {
      client: {
        javascript: {
          code_version: BUILD_ID,
          source_map_enabled: true,
          guess_uncaught_frames: true,
        },
      },
    },
    ignoredMessages: [
      // ignore uncaught exceptions from iframes https://docs.rollbar.com/docs/unknown-script-error
      // that do not cover by checkIgnore
      'Script error.',
      '^(unknown)',
      'Request failed with status code 404',
      'Request failed with status code 409',
    ],
  });

  return getRollbar();
};

export const enableRollbarReplay = () => {
  getRollbar().configure({
    replay: {
      enabled: true,
      maskInputOptions: {
        password: true,
        email: true,
      },
      blockClass: 'rb-block',
      maskTextClass: 'rb-mask',
      triggers: [
        {
          type: 'occurrence',
          level: ['critical'],
          samplingRatio: 0.5,
          preDuration: 20,
          postDuration: 5,
        },
      ],
    },
  });
};

export const setUser = ({id}: {id: number | null}) => {
  getRollbar().configure({
    payload: {
      person: {
        id,
      },
    },
  });
};
